const back_end = [
    {
        name: 'Node Js',
        imgUrl: '/technologies/nodejs.svg'
    },
    {
        name: 'Laravel',
        imgUrl: '/technologies/laravel.svg'
    },
    {
        name: 'Express',
        imgUrl: '/technologies/express.png'
    },
    {
        name: 'Rails',
        imgUrl: '/technologies/rails.svg'
    }
]

export default back_end